import React from 'react';
import { Navigate } from 'react-router-dom';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireAuth?: boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requireAuth = false }) => {
  const token = localStorage.getItem('token');
  const user = localStorage.getItem('user');

  console.log('ProtectedRoute check:', { requireAuth, hasToken: !!token, hasUser: !!user, pathname: window.location.pathname });

  // If route requires authentication and user is not logged in, redirect to login
  if (requireAuth && !token) {
    console.log('Redirecting to login - no token');
    return <Navigate to="/login" replace />;
  }

  // If user is logged in, check role-based access
  if (token && user) {
    const userData = JSON.parse(user);
    console.log('User data in ProtectedRoute:', userData);
    
    // If trying to access login page, redirect to appropriate dashboard
    if (window.location.pathname === '/login') {
      if (userData.is_main_seller) {
        // Main seller - redirect to main dashboard
        return <Navigate to="/main" replace />;
      } else if (userData.branch_id) {
        // Branch manager - redirect to branch medicines
        return <Navigate to="/branch/medicines" replace />;
      }
    }
    
    // Role-based route protection
    if (window.location.pathname.startsWith('/main') && !userData.is_main_seller) {
      console.log('Branch manager trying to access admin routes, redirecting to branch medicines');
      return <Navigate to="/branch/medicines" replace />;
    }
    
    if (window.location.pathname.startsWith('/branch') && userData.is_main_seller) {
      console.log('Admin trying to access branch routes, redirecting to main dashboard');
      return <Navigate to="/main" replace />;
    }
  }

  return <>{children}</>;
};

export default ProtectedRoute;
